import * as Preact from 'preact'
import * as styles from './index.css'

const { h } = Preact

interface IProps {
  class?: string
}

export const PlayIcon = (props: IProps) => {
  return (
    <svg class={props.class} viewBox="0 0 15 15">
      <use xlinkHref="#nrk-media-play" />
    </svg>
  )
}
